export default {
  useNextVariants: true,
  fontSizes: {
    feature: 16,
    subtitle: 20,
    title: 32,
  },
  fontWeightBold: 700,
};
